export class NativeStreamProbeIssue {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "rowIndex",
            "baseName": "rowIndex",
            "type": "number",
            "format": ""
        },
        {
            "name": "udf",
            "baseName": "udf",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceLine",
            "baseName": "sourceLine",
            "type": "number",
            "format": ""
        },
        {
            "name": "sourceColumn",
            "baseName": "sourceColumn",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamProbeIssue.attributeTypeMap;
    }
    constructor() {
    }
}
